const formValidation = {
    /**
       * validates an Australia Business Number
       * @param {string} value 
       * @returns {boolean}
       * @see https://abr.business.gov.au/Help/AbnFormat
       */
    abn(value) {
        const weightsArr = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19]
        let sum = 0, abnParsed = value.trim().replace(/\s/g, "")
        abnParsed = (Math.abs(+abnParsed.charAt(0) - 1)) + abnParsed.slice(1)
        for (const index in abnParsed) {
            sum += (+abnParsed[index] * weightsArr[index])
        }
        return sum % 89 === 0
    },

    /**
     * validates an Australia Post Code
     * @param {string} value 
     * @returns {boolean}
     * @see https://stackoverflow.com/a/6319814
     */
    ausPostCode(value) {
        const ausPostCodeRegex = /^(0[289][0-9]{2})|([1-9][0-9]{3})$/
        return ausPostCodeRegex.test(value)
    },

    /**
     * validates an Australia Phone number
     * @param {string} value 
     * @returns {boolean}
     */
    ausPhone(value) {
        const ausPhoneRegex = /^(?:\+?(61))? ?(?:\((?=.*\)))?(0?[2-57-8])\)? ?(\d\d(?:- |(?![- ]?\d[- ]))\d\d[- ]?\d[- ]?\d{3})$/
        return ausPhoneRegex.test(value)
    },
    buildRequiredNodValidation(selector, label) {
        return { selector: selector, validate: 'presence', errorMessage: `The '${label}' field cannot be blank.` }
    }
}

/**
 * 
 * @param {HTMLFormElement} form 
 * @returns {Object}
 */
const serializeFormData = (form) => {
    const formData = new FormData(form);
    const obj = {};
    for (const [key, value] of formData.entries()) {
        if (obj.hasOwnProperty(key)) {
            if (Array.isArray(obj[key])) {
                obj[key].push(value);
            } else {
                obj[key] = [obj[key], value];
            }
        } else {
            obj[key] = value;
        }
    }
    return obj;
};
window.formValidation = formValidation;
window.serializeFormData = serializeFormData;